import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { TBannerType } from "@/typings/Props";
import Header from "@/components/main/Header";
import Banner from "@/components/learn/Banner";
import ResultSheetGuide from "@/components/learn/ResultSheetGuide";
import EcoSystem from "@/components/products/detail/EcoSystem";
import ResultSheetImage from "@/components/learn/ResultSheet";
import ContactUs from "@/components/contact-us";
import Footer from "@/components/main/Footer";

export default function BodyCompositionResultSheet() {
  const router = useRouter();
  const { t } = useTranslation();

  const bannerData: TBannerType[] = [
    {
      id: 1,
      name: "body-composition-result-sheet",
      bg: "/learn/banner/Body-Composition-Result-Sheet-Banner.webp",
      title: t("menu.learn.result.banner.body-composition-result-sheet"),
      youtube: "https://www.youtube.com/embed/sG0GA9IhTUQ",
      resultSheet: [
        {
          id: 1,
          category: t("products.inbody970"),
          image: "/learn/result-interpretation/body-composition/Result-Sheets-InBody970-scaled.webp",
          spots: [
            { id: "+", desc: t("menu.learn.result.sheet.1.1"), coord: { x: "0.251297%", y: "11.1841%" } },
            { id: "+", desc: t("menu.learn.result.sheet.1.2"), coord: { x: "0%", y: "27.0477%" } },
            { id: "+", desc: t("menu.learn.result.sheet.1.3"), coord: { x: "0.239137%", y: "40.1976%" } },
            { id: "+", desc: t("menu.learn.result.sheet.1.4"), coord: { x: "0%", y: "50.6614%" } },
            { id: "+", desc: t("menu.learn.result.sheet.1.5"), coord: { x: "0%", y: "70.4425%" } },
            { id: "+", desc: t("menu.learn.result.sheet.1.6"), coord: { x: "0%", y: "78.0643%" } },
            { id: "+", desc: t("menu.learn.result.sheet.1.7"), coord: { x: "60.4815%", y: "13.147%" } },
            { id: "+", desc: t("menu.learn.result.sheet.1.8"), coord: { x: "60.7004%", y: "22.0772%" } },
            { id: "+", desc: t("menu.learn.result.sheet.1.9"), coord: { x: "61.0044%", y: "40.0172%" } },
            { id: "+", desc: t("menu.learn.result.sheet.1.10"), coord: { x: "61.0125%", y: "49.051%" } },
            { id: "+", desc: t("menu.learn.result.sheet.1.11"), coord: { x: "61.2597%", y: "61.9381%" } },
            { id: "+", desc: t("menu.learn.result.sheet.1.12"), coord: { x: "61.2719%", y: "67.0442%" } },
          ],
        },
        {
          id: 2,
          category: t("products.inbody770"),
          image: "/learn/result-interpretation/body-composition/Result-Sheets-InBody770-scaled-1.webp",
          spots: [
            { id: "+", desc: t("menu.learn.result.sheet.2.1"), coord: { x: "0.251297%", y: "11.1841%" } },
            { id: "+", desc: t("menu.learn.result.sheet.2.2"), coord: { x: "0.502594%", y: "24.6474%" } },
            { id: "+", desc: t("menu.learn.result.sheet.2.3"), coord: { x: "0.502594%", y: "36.8721%" } },
            { id: "+", desc: t("menu.learn.result.sheet.2.4"), coord: { x: "0.243191%", y: "46.7804%" } },
            { id: "+", desc: t("menu.learn.result.sheet.2.5"), coord: { x: "0%", y: "66.9753%" } },
            { id: "+", desc: t("menu.learn.result.sheet.2.6"), coord: { x: "60.4815%", y: "70.4406%" } },
            { id: "+", desc: t("menu.learn.result.sheet.2.7"), coord: { x: "0%", y: "74.5728%" } },
            { id: "+", desc: t("menu.learn.result.sheet.2.8"), coord: { x: "60.745%", y: "13.5837%" } },
            { id: "+", desc: t("menu.learn.result.sheet.2.9"), coord: { x: "61.2719%", y: "21.703%" } },
            { id: "+", desc: t("menu.learn.result.sheet.2.10"), coord: { x: "60.7409%", y: "38.664%" } },
            { id: "+", desc: t("menu.learn.result.sheet.2.11"), coord: { x: "61.0125%", y: "46.6915%" } },
            { id: "+", desc: t("menu.learn.result.sheet.2.12"), coord: { x: "60.9598%", y: "57.7953%" } },
            { id: "+", desc: t("menu.learn.result.sheet.2.13"), coord: { x: "60.441%", y: "76.7168%" } },
          ],
        },
        {
          id: 3,
          category: t("products.inbody580"),
          image: "/learn/result-interpretation/body-composition/Result-Sheets-InBody580-scaled.webp",
          spots: [
            { id: "+", desc: t("menu.learn.result.sheet.3.1"), coord: { x: "0.251297%", y: "11.1841%" } },
            { id: "+", desc: t("menu.learn.result.sheet.3.2"), coord: { x: "0.502594%", y: "24.6474%" } },
            { id: "+", desc: t("menu.learn.result.sheet.3.3"), coord: { x: "0.502594%", y: "36.8721%" } },
            { id: "+", desc: t("menu.learn.result.sheet.3.4"), coord: { x: "0.243191%", y: "46.7804%" } },
            { id: "+", desc: t("menu.learn.result.sheet.3.5"), coord: { x: "0%", y: "66.9753%" } },
            { id: "+", desc: t("menu.learn.result.sheet.3.6"), coord: { x: "50.1054%", y: "66.9381%" } },
            { id: "+", desc: t("menu.learn.result.sheet.3.7"), coord: { x: "0%", y: "74.5728%" } },
            { id: "+", desc: t("menu.learn.result.sheet.3.8"), coord: { x: "60.745%", y: "13.5837%" } },
            { id: "+", desc: t("menu.learn.result.sheet.3.9"), coord: { x: "61.2719%", y: "21.703%" } },
            { id: "+", desc: t("menu.learn.result.sheet.3.10"), coord: { x: "60.7409%", y: "38.664%" } },
            { id: "+", desc: t("menu.learn.result.sheet.3.11"), coord: { x: "61.0125%", y: "46.6915%" } },
            { id: "+", desc: t("menu.learn.result.sheet.3.12"), coord: { x: "60.9598%", y: "57.7953%" } },
            { id: "+", desc: t("menu.learn.result.sheet.3.13"), coord: { x: "60.7004%", y: "72.4771%" } },
          ],
        },
        {
          id: 4,
          category: t("products.inbody380"),
          image: "/learn/result-interpretation/body-composition/Result-Sheets-InBody380-scaled.webp",
          spots: [
            { id: "+", desc: t("menu.learn.result.sheet.4.1"), coord: { x: "0.252048%", y: "12.6532%" } },
            { id: "+", desc: t("menu.learn.result.sheet.4.2"), coord: { x: "0.502594%", y: "24.6474%" } },
            { id: "+", desc: t("menu.learn.result.sheet.4.3"), coord: { x: "0.502594%", y: "36.8721%" } },
            { id: "+", desc: t("menu.learn.result.sheet.4.4"), coord: { x: "0.243191%", y: "46.7804%" } },
            { id: "+", desc: t("menu.learn.result.sheet.4.5"), coord: { x: "0%", y: "66.9667%" } },
            { id: "+", desc: t("menu.learn.result.sheet.4.6"), coord: { x: "49.5379%", y: "67.3423%" } },
            { id: "+", desc: t("menu.learn.result.sheet.4.7"), coord: { x: "0.303988%", y: "74.6445%" } },
            { id: "+", desc: t("menu.learn.result.sheet.4.8"), coord: { x: "61.2638%", y: "13.4719%" } },
            { id: "+", desc: t("menu.learn.result.sheet.4.9"), coord: { x: "60.745%", y: "23.125%" } },
            { id: "+", desc: t("menu.learn.result.sheet.4.10"), coord: { x: "60.7531%", y: "31.7947%" } },
            { id: "+", desc: t("menu.learn.result.sheet.4.11"), coord: { x: "60.7409%", y: "43.8016%" } },
            { id: "+", desc: t("menu.learn.result.sheet.4.12"), coord: { x: "61.0125%", y: "58.2511%" } },
          ],
        },
        {
          id: 5,
          category: t("products.inbody270"),
          image: "/learn/result-interpretation/body-composition/Result-Sheets-InBody270-scaled.webp",
          spots: [
            { id: "+", desc: t("menu.learn.result.sheet.5.1"), coord: { x: "0.252048%", y: "12.6532%" } },
            { id: "+", desc: t("menu.learn.result.sheet.5.2"), coord: { x: "0.504096%", y: "28.8686%" } },
            { id: "+", desc: t("menu.learn.result.sheet.5.3"), coord: { x: "0.504111%", y: "43.8447%" } },
            { id: "+", desc: t("menu.learn.result.sheet.5.4"), coord: { x: "0.504111%", y: "56.3224%" } },
            { id: "+", desc: t("menu.learn.result.sheet.5.5"), coord: { x: "30.2458%", y: "56.3252%" } },
            { id: "+", desc: t("menu.learn.result.sheet.5.6"), coord: { x: "0.252048%", y: "81.1052%" } },
            { id: "+", desc: t("menu.learn.result.sheet.5.7"), coord: { x: "60.4876%", y: "13.5445%" } },
            { id: "+", desc: t("menu.learn.result.sheet.5.8"), coord: { x: "60.4876%", y: "22.2816%" } },
            { id: "+", desc: t("menu.learn.result.sheet.5.9"), coord: { x: "60.4876%", y: "31.016%" } },
            { id: "+", desc: t("menu.learn.result.sheet.5.10"), coord: { x: "60.2355%", y: "35.6506%" } },
            { id: "+", desc: t("menu.learn.result.sheet.5.11"), coord: { x: "60.4836%", y: "45.4545%" } },
            { id: "+", desc: t("menu.learn.result.sheet.5.12"), coord: { x: "60.2355%", y: "65.5916%" } },
          ],
        },
        {
          id: 6,
          category: t("products.bwa2.0"),
          image: "/learn/result-interpretation/body-composition/Result-Sheets-BWA-2.0-scaled.webp",
          spots: [
            { id: "+", desc: t("menu.learn.result.sheet.6.1"), coord: { x: "0.251297%", y: "11.1841%" } },
            { id: "+", desc: t("menu.learn.result.sheet.6.2"), coord: { x: "0%", y: "27.0477%" } },
            { id: "+", desc: t("menu.learn.result.sheet.6.3"), coord: { x: "0.239137%", y: "40.1976%" } },
            { id: "+", desc: t("menu.learn.result.sheet.6.4"), coord: { x: "0%", y: "50.6614%" } },
            { id: "+", desc: t("menu.learn.result.sheet.6.5"), coord: { x: "0%", y: "70.4425%" } },
            { id: "+", desc: t("menu.learn.result.sheet.6.6"), coord: { x: "0%", y: "78.0643%" } },
            { id: "+", desc: t("menu.learn.result.sheet.6.7"), coord: { x: "60.4815%", y: "13.147%" } },
            { id: "+", desc: t("menu.learn.result.sheet.6.8"), coord: { x: "60.7004%", y: "22.0772%" } },
            { id: "+", desc: t("menu.learn.result.sheet.6.9"), coord: { x: "61.5232%", y: "40.5701%" } },
            { id: "+", desc: t("menu.learn.result.sheet.6.10"), coord: { x: "60.7531%", y: "48.8675%" } },
            { id: "+", desc: t("menu.learn.result.sheet.6.11"), coord: { x: "61.2597%", y: "61.9381%" } },
            { id: "+", desc: t("menu.learn.result.sheet.6.12"), coord: { x: "61.2719%", y: "67.2276%" } },
          ],
        },
        {
          id: 7,
          category: t("products.inbodys10"),
          image: "/learn/result-interpretation/body-composition/Result-Sheets-InBody-S10-scaled-1.webp",
          spots: [
            { id: "+", desc: t("menu.learn.result.sheet.7.1"), coord: { x: "0.251297%", y: "11.1841%" } },
            { id: "+", desc: t("menu.learn.result.sheet.7.2"), coord: { x: "0%", y: "27.0477%" } },
            { id: "+", desc: t("menu.learn.result.sheet.7.3"), coord: { x: "0.239137%", y: "40.1976%" } },
            { id: "+", desc: t("menu.learn.result.sheet.7.4"), coord: { x: "0%", y: "50.6614%" } },
            { id: "+", desc: t("menu.learn.result.sheet.7.5"), coord: { x: "0%", y: "70.4425%" } },
            { id: "+", desc: t("menu.learn.result.sheet.7.6"), coord: { x: "0%", y: "78.0643%" } },
            { id: "+", desc: t("menu.learn.result.sheet.7.7"), coord: { x: "60.4815%", y: "13.147%" } },
            { id: "+", desc: t("menu.learn.result.sheet.7.8"), coord: { x: "60.7004%", y: "22.0772%" } },
            { id: "+", desc: t("menu.learn.result.sheet.7.9"), coord: { x: "61.5232%", y: "40.5701%" } },
            { id: "+", desc: t("menu.learn.result.sheet.7.10"), coord: { x: "60.7531%", y: "48.3191%" } },
            { id: "+", desc: t("menu.learn.result.sheet.7.11"), coord: { x: "61.2597%", y: "59.9209%" } },
            { id: "+", desc: t("menu.learn.result.sheet.7.12"), coord: { x: "61.5313%", y: "70.1652%" } },
            { id: "+", desc: t("menu.learn.result.sheet.7.13"), coord: { x: "60.7004%", y: "76.0946%" } },
          ],
        },
      ],
    },
    {
      id: 2,
      name: "body-water-result-sheet",
      bg: "/learn/banner/banner-2-1.png",
      title: "Body Water Result Sheet",
      youtube: "https://www.youtube.com/embed/f7K8FojOEks",
      resultSheetImg: "/learn/result-interpretation/Result-Assessment-Body-Water.webp",
      resultSheetSpots: [
        { id: "+", desc: t("menu.learn.result.sheet.8.1"), coord: { x: "0.251297%", y: "11.3675%" } },
        { id: "+", desc: t("menu.learn.result.sheet.8.2"), coord: { x: "0.243191%", y: "25.3813%" } },
        { id: "+", desc: t("menu.learn.result.sheet.8.3"), coord: { x: "0%", y: "33.5694%" } },
        { id: "+", desc: t("menu.learn.result.sheet.8.4"), coord: { x: "0.502594%", y: "54.3033%" } },
        { id: "+", desc: t("menu.learn.result.sheet.8.5"), coord: { x: "0%", y: "74.6732%" } },
        { id: "+", desc: t("menu.learn.result.sheet.8.6"), coord: { x: "60.4329%", y: "13.2139%" } },
        { id: "+", desc: t("menu.learn.result.sheet.8.7"), coord: { x: "60.745%", y: "23.2683%" } },
        { id: "+", desc: t("menu.learn.result.sheet.8.8"), coord: { x: "61.0044%", y: "32.371%" } },
        { id: "+", desc: t("menu.learn.result.sheet.8.9"), coord: { x: "61.2638%", y: "37.2534%" } },
        { id: "+", desc: t("menu.learn.result.sheet.8.10"), coord: { x: "61.2719%", y: "46.1067%" } },
        { id: "+", desc: t("menu.learn.result.sheet.8.11"), coord: { x: "60.7409%", y: "61.4163%" } },
      ],
    },
    {
      id: 3,
      name: "evaluation-result-sheet",
      bg: "/learn/banner/bodywater-resultsheet-banner-1.png",
      title: t("menu.learn.result.banner.evaluation-result-sheet"),
      youtube: "https://www.youtube.com/embed/QhACoOH7fGY",
      resultSheetImg: "/learn/result-interpretation/Result-Sheets-Evaluation-scaled.webp",
      resultSheetSpots: [
        { id: "+", desc: t("menu.learn.result.sheet.9.1"), coord: { x: "0%", y: "12.6457%" } },
        { id: "+", desc: t("menu.learn.result.sheet.9.2"), coord: { x: "0%", y: "54.0819%" } },
        { id: "+", desc: t("menu.learn.result.sheet.9.3"), coord: { x: "46.952%", y: "12.36%" } },
        { id: "+", desc: t("menu.learn.result.sheet.9.4"), coord: { x: "46.9317%", y: "54.1191%" } },
      ],
    },
    {
      id: 4,
      name: "children-result-sheet",
      bg: "/learn/banner/children-resultsheet-banner-1.png",
      title: t("menu.learn.result.banner.children-result-sheet"),
      youtube: "",
      resultSheetImg: "/learn/result-interpretation/Result-Sheets-Children-scaled.webp",
      resultSheetSpots: [
        { id: "+", desc: t("menu.learn.result.sheet.10.1"), coord: { x: "0%", y: "10.992%" } },
        { id: "+", desc: t("menu.learn.result.sheet.10.2"), coord: { x: "0%", y: "25.4558%" } },
        { id: "+", desc: t("menu.learn.result.sheet.10.3"), coord: { x: "0%", y: "38.0476%" } },
        { id: "+", desc: t("menu.learn.result.sheet.10.4"), coord: { x: "0%", y: "48.7959%" } },
        { id: "+", desc: t("menu.learn.result.sheet.10.5"), coord: { x: "0%", y: "77.4312%" } },
        { id: "+", desc: t("menu.learn.result.sheet.10.6"), coord: { x: "60.7004%", y: "13.0275%" } },
        { id: "+", desc: t("menu.learn.result.sheet.10.7"), coord: { x: "60.7004%", y: "21.8349%" } },
        { id: "+", desc: t("menu.learn.result.sheet.10.8"), coord: { x: "60.6923%", y: "33.2999%" } },
        { id: "+", desc: t("menu.learn.result.sheet.10.9"), coord: { x: "60.441%", y: "44.4037%" } },
      ],
    },
  ];
  const banner = bannerData.find(
    (b) => b.name === router.asPath.split("/").pop() || `${b.name}#` === router.asPath.split("/").pop()
  );

  return (
    <>
      <Header />
      <Banner
        key={router.asPath}
        Bg={banner && banner.bg}
        $fontSize="3.5rem"
        $contentWidth="622px"
        Headline={t("menu.learn.result-interpretation")}
        Title={banner && banner.title}
        Desc={t("menu.learn.result.banner.desc")}
        isResultSheet={true}
      />
      <TitleBannerWrapper>
        <TitleArea $width="35%">
          <TitleBannerText>{t("menu.learn.result.title-banner.title")}</TitleBannerText>
        </TitleArea>
        <TitleArea $width="55%">
          <TitleBannerDesc>{banner && t(`menu.learn.result.title-banner.desc-${banner.id}`)}</TitleBannerDesc>
          <TitleBannerSamllDesc>{t("menu.learn.result.title-banner.small-desc")}</TitleBannerSamllDesc>
        </TitleArea>
      </TitleBannerWrapper>
      {banner?.resultSheetImg && (
        <EcoSystemWrap>
          <EcoSystemContent>
            {banner.resultSheetSpots && (
              <EcoSystem isBlock ecoImg={banner.resultSheetImg} ecoSystem={banner.resultSheetSpots} />
            )}
          </EcoSystemContent>
        </EcoSystemWrap>
      )}
      {banner?.resultSheet && <ResultSheetImage datas={banner.resultSheet} />}
      {banner?.youtube && (
        <YoutubeWrap>
          <IframeWrap>
            <IFrame loading="lazy" src={banner.youtube} />
          </IframeWrap>
        </YoutubeWrap>
      )}
      <ResultSheetGuide bannerData={banner}></ResultSheetGuide>
      <ContactUs />
      <Footer />
    </>
  );
}

const TitleBannerWrapper = styled.div`
  width: 100%;
  height: 230px;
  display: flex;
  justify-content: center;
  margin-top: 30px;

  @media (max-width: 1000px) {
    flex-wrap: wrap;
    height: auto;
  }
`;
const TitleArea = styled.div<{ $width: string }>`
  width: ${({ $width }) => $width};
  height: 100%;

  @media (max-width: 1000px) {
    width: 85%;
    padding: 10px 30px;
  }
`;

const TitleBannerText = styled.p`
  font-size: 2.5rem;
  font-weight: 700;
  color: #971b2f;
`;

const TitleBannerDesc = styled.p`
  color: #676767;
  line-height: 150%;
  white-space: pre-wrap;
`;
const TitleBannerSamllDesc = styled(TitleBannerDesc)`
  font-size: 0.9rem;
  color: #676767;
  line-height: 150%;
  margin-top: 20px;
`;

const YoutubeWrap = styled.div`
  margin: 50px auto;
  max-width: 768px;

  @media (max-width: 1200px) {
    padding: 0 20px;
  }
`;
const IframeWrap = styled.div`
  position: relative;
  padding-top: 56.25%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const IFrame = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
`;

const EcoSystemWrap = styled.div`
  margin: 50px auto 0 auto;
  padding: 46px;
  max-width: 768px;
  border-radius: 10px;
  background-color: #fff;
`;
const EcoSystemContent = styled.div`
  position: relative;

  img {
    width: 100%;
    vertical-align: top;
  }
`;
